export default __webpack_public_path__ + "515e6ae.png";